import { useUnfinishedExams } from "src/hooks/useExams";

import DefaultView from "./DefaultView";

export default function UnfinishedExamsShortView() {
	const { isLoading, data: { rows } = {} } = useUnfinishedExams({
		orderBy: "updatedAt",
		order: "DESC",
		page: 0,
		take: 2,
	});

	return <DefaultView isLoading={isLoading} rows={rows} rowsToShow={2} />;
}
